import { MainColor } from '../../palette/colors';

export const getInputTheme = () => {
  return {
    defaultColors: {
      defaultState: {
        inputColor: 'navy95' as MainColor,
        placeholderColor: 'coolGrey60' as MainColor,
        labelColor: 'coolGrey60' as MainColor,
        startIconColor: 'coolGrey60' as MainColor,
        endIconColor: 'coolGrey60' as MainColor,
        backgroundColor: 'white95' as MainColor,
        borderColor: 'coolGrey30' as MainColor,
      },
      hover: 'navy60' as MainColor,
      active: 'navy50' as MainColor,
      focus: 'navy40' as MainColor,
      disabled: {
        startIconColor: 'coolGrey50' as MainColor,
        color: 'coolGrey50' as MainColor,
        backgroundColor: 'coolGrey10' as MainColor,
      },
      error: {
        inputColor: 'red50' as MainColor,
        startIconColor: 'red50' as MainColor,
        borderColor: 'red50' as MainColor,
      },
    },
    selectFieldItem: {
      defaultState: {
        color: 'navy95' as MainColor,
        backgroundColor: 'white95' as MainColor,
        dropdownIndicator: 'coolGrey60' as MainColor,
      },
      hover: 'navy10' as MainColor,
      focus: 'navy10' as MainColor,
    },
    list: {
      defaultState: {
        labelColor: 'coolGrey60' as MainColor,
        optionLabelColor: 'navy95' as MainColor,
        optionCircleColor: 'coolGrey60' as MainColor,
      },
      error: {
        labelColor: 'red50' as MainColor,
      },
    },
  };
};

export type InputTheme = ReturnType<typeof getInputTheme>;
